export const CONFIRMATION_MESSAGE = 'Are you sure you want to delete this column?';
